import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, computed, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  RCIPInspectionRequestVM,
  RCIPInspectionWizardVM,
} from '../../../../data/models/coverage-validator-api-models';
import { ButtonComponent, UI_FORM_IMPORTS } from '../../../../ui-common';
import { YES_NO_OPTIONS, payrollLabel, percentText, yesNoId } from '../rcip-wizard.helpers';

@Component({
  selector: 'app-rcip-operations',
  templateUrl: './rcip-operations.html',
  styleUrl: './rcip-operations.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, CurrencyPipe, ButtonComponent, ...UI_FORM_IMPORTS],
})
export class RcipOperations implements OnInit {
  answers = input.required<RCIPInspectionRequestVM>();
  legacy = input.required<boolean>();
  back = output<void>();
  next = output<Partial<RCIPInspectionWizardVM>>();

  protected readonly yesNoOptions = YES_NO_OPTIONS;
  protected readonly percentText = percentText;
  protected payrollLabel = computed(() => payrollLabel(this.legacy()));

  protected form = new FormGroup({
    descriptionOfOperations: new FormControl('', { nonNullable: true, validators: Validators.required }),
    performNewConstruction: new FormControl<string | null>(null, Validators.required),
    usesDayLabor: new FormControl<string | null>(null, Validators.required),
  });

  ngOnInit(): void {
    const answers = this.answers();
    this.form.setValue({
      descriptionOfOperations: answers.descriptionOfOperations ?? '',
      performNewConstruction: yesNoId(answers.performNewConstruction),
      usesDayLabor: yesNoId(answers.usesDayLabor),
    });
  }

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    this.next.emit({
      descriptionOfOperations: value.descriptionOfOperations.trim(),
      performNewConstruction: value.performNewConstruction === 'yes',
      usesDayLabor: value.usesDayLabor === 'yes',
    });
  }
}
